import { Helmet } from 'react-helmet-async';
import CustomBreadcrumbs, { type CustomBreadcrumbsProps } from 'lib/custom-breadcrumbs';
import { type ReactNode, type PropsWithChildren, memo } from "react";
import Box, { type BoxProps } from '@mui/material/Box';

type Props = Pick<BoxProps, 'sx'> & {
    readonly title?: ReactNode;
    readonly breadcrumbsProps: CustomBreadcrumbsProps;
};

const Resource = ({ sx, title, breadcrumbsProps, children }: PropsWithChildren<Props>) => (
    <Box
        sx={{
            px: '20px',
            ...sx,
        }}
    >
        {Boolean(title) && (
            <Helmet>
                <title>{title}</title>
            </Helmet>
        )}
        {Boolean(breadcrumbsProps) && (
            <CustomBreadcrumbs
                {...breadcrumbsProps}
            />
        )}
        {children}
    </Box>
);

export default memo(Resource);
